import { TableHeadItem } from "../common/TableHeadItem";
import {TableRow} from "../common/TableRow";
import styles from "./Table.module.scss";
import { TableRowRegistrationButton } from "../TableRowRegistrationButton";
import { generateUniqueNumber } from '../../utils/numbers';
import React, { useEffect } from 'react';
import { TableRowTrigger } from '../../apollo/types/TableRowTrigger';

type TableProps = {
  uniqueKey?: number
  table: {
    theadData: string[];
    tbodyData: Array<{ id: string; items: string[] }>;
  };
  readOnly?: boolean;
  isChange?: boolean;
  personalData?: string[];
  handleChangePersonalData?: Function;
  triggerChange?: Function
  lastItemThatTriggered?: TableRowTrigger
};


export const Table = ({
  uniqueKey,
  table,
  readOnly = false,
  isChange,
  personalData,
  handleChangePersonalData,
  triggerChange,
  lastItemThatTriggered,
}: TableProps) => {
  if(!uniqueKey) {
    uniqueKey = generateUniqueNumber()
  }

  return (
    <table cellSpacing='0' className={styles.table}>
      <thead>
        <tr className={styles.row}>
          {table.theadData.map((head) => (
            <TableHeadItem key={head} item={head} />
          ))}
        </tr>
      </thead>
      <tbody>
        {readOnly ? (
          table.tbodyData.map((item) => (
            <TableRow
              tableKey={uniqueKey}
              key={item.id}
              data={item.items ?? ['']}
              isChange={isChange}
              triggerChange={triggerChange}
              personalData={personalData}
              handleChangePersonalData={handleChangePersonalData}
              lastItemThatTriggered={lastItemThatTriggered}
            />
          ))
        ) : (
          <TableRowRegistrationButton />
        )}
      </tbody>
    </table>
  );
};
